export default "__VITE_ASSET__Cs2vV4ru__"